import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TelegramIcon from '@mui/icons-material/Telegram';
import MessageIcon from '@mui/icons-material/Message';

export const PROVIDER_CONFIG = {
    2: { name: 'WhatsApp',    icon: <WhatsAppIcon    style={{ fontSize: 56 }} />, color: '#25D366' },
    3: { name: 'Instagram',   icon: <InstagramIcon   style={{ fontSize: 56 }} />, color: '#E4405F' },
    4: { name: 'Messenger',   icon: <FacebookIcon    style={{ fontSize: 56 }} />, color: '#0084FF' },
    5: { name: 'Telegram',    icon: <TelegramIcon    style={{ fontSize: 56 }} />, color: '#0088cc' },
    default: { name: 'Genérico', icon: <MessageIcon style={{ fontSize: 56 }} />, color: '#666' }
};

export const PROVIDER_CONFIG_NAME = {
    WHATSAPP: 2,
    INSTAGRAM: 3,
    MESSENGER: 4,
    TELEGRAM: 5,
    
};